const deferralTriggerEvents = [
  "mousemove",
  "touchstart",
  "keydown",
  "mousedown",
  "scroll",
];

function executeScript(script: HTMLScriptElement): void {
  const newScript = document.createElement("script");
  newScript.dataset.deferred = "true";
  if (script.src) {
    newScript.src = script.src;
    newScript.async = script.async;
  }
  if (script.text) {
    newScript.text = script.text;
  }
  script.parentNode.replaceChild(newScript, script);
}

function executeScriptAsync(script: HTMLScriptElement): Promise<void> {
  return new Promise((resolve) => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(
        () => {
          executeScript(script);
          resolve();
        },
        { timeout: 1000 }
      );
    } else {
      executeScript(script);
      resolve();
    }
  });
}

async function executeScripts() {
  for (const event of deferralTriggerEvents) {
    document.removeEventListener(event, executeScripts);
  }
  const scripts = Array.from(
    document.querySelectorAll("script[type='text/x-pagespeed-optimize']")
  ) as HTMLScriptElement[];
  for (const script of scripts) {
    await executeScriptAsync(script);
  }
}

export function queueForDeferral() {
  for (const event of deferralTriggerEvents) {
    document.addEventListener(event, executeScripts, { passive: true });
  }
}
